// extracted by mini-css-extract-plugin
module.exports = {"active-tasks":"active-tasks_active-tasks__2S1n8","loader":"active-tasks_loader__3tTSx","footer":"active-tasks_footer__yl7it"};